document.querySelectorAll("div").forEach((container) => {
    container.querySelectorAll("h1, h2, h3, h4, h5, h6, p, span").forEach((textElement) => {
        textElement.innerHTML = textElement.innerHTML.replace(
            /(?<!<span[^>]*>)®(?!<\/span>)/g,
            '<span style="font-size: 70%; vertical-align: super;">®</span>'
        );
    });
});
